module.exports = __webpack_public_path__ + "static/media/azure-fundamentals.c5a04932.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/azure-fundamentals.png
// module id = 1378
// module chunks = 0